module.exports = __webpack_public_path__ + "media/images/icon__point--default@3x-57eba6c9c1d40bc6701d4bb3fcecf0f5.png";